import { render, staticRenderFns } from "./MinisiteLanding.vue?vue&type=template&id=f1273bd8&scoped=true&"
import script from "./MinisiteLanding.vue?vue&type=script&lang=js&"
export * from "./MinisiteLanding.vue?vue&type=script&lang=js&"
import style0 from "./MinisiteLanding.vue?vue&type=style&index=0&id=f1273bd8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1273bd8",
  null
  
)

export default component.exports